export enum ProductLayerEnum {
  RANKING = 'ranking',
  EQUALIZE = 'equalize',
}
